import { Controller, Control, FieldValues } from 'react-hook-form';

type Props<T extends FieldValues = FieldValues> = {
  name: string;
  control: Control<T>;
  defaultValue?: string;
};

/**
 * A React functional component that renders a hidden input field using the `Controller` component from `react-hook-form`.
 *
 * @param {Props} props - The properties passed to the component.
 * @param {string} props.name - The name of the input field.
 * @param {any} props.control - The control object from `react-hook-form` used to manage the form state.
 *
 * @returns {JSX.Element} A hidden input field controlled by `react-hook-form`.
 */

export const HiddenInputField = <T extends FieldValues = FieldValues>(props: Props<T>) => {
  const { name, control, defaultValue } = props;
  return (
    <Controller
      name={name as any}
      control={control}
      defaultValue={"" as any}
      render={({ field }) => <input type="hidden" {...field} defaultValue={defaultValue} />}
    />
  );
};
